'use client';

import { c as _c } from "react/compiler-runtime";
import { Container } from '@/app/components/layouts/container';
import { Section } from '@/app/components/layouts/section';
import { Image } from '@/app/components/media/image';
import { generateSources } from '@/app/components/media/image/generate-sources';
import { ContentBlock } from '@/app/components/sections/service/service-center/image-with-cta/content-block';
import type { ServiceCenterImageWithCTAProps } from '@/app/components/sections/service/service-center/image-with-cta/types';
import styles from '@/app/components/sections/service/service-center/style.module.css';
import { useRevealAnim } from '@/app/hooks/useRevealAnim';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
export const ServiceCenterImageWithCTA = t0 => {
  const $ = _c(52);
  let className;
  let image;
  let imageDesktop;
  let logo;
  let logoClassName;
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let title;
  let titleClassName;
  let tracking;
  if ($[0] !== t0) {
    ({
      className,
      layout: t1,
      theme: t2,
      variant: t3,
      title,
      image,
      imageDesktop,
      logo,
      buttons: t4,
      testId: t5,
      titleClassName,
      logoClassName,
      tracking,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = image;
    $[3] = imageDesktop;
    $[4] = logo;
    $[5] = logoClassName;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = title;
    $[13] = titleClassName;
    $[14] = tracking;
  } else {
    className = $[1];
    image = $[2];
    imageDesktop = $[3];
    logo = $[4];
    logoClassName = $[5];
    props = $[6];
    t1 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    title = $[12];
    titleClassName = $[13];
    tracking = $[14];
  }
  const layout = t1 === undefined ? "grid" : t1;
  const theme = t2 === undefined ? "dark" : t2;
  const variant = t3 === undefined ? "dark" : t3;
  let t6;
  if ($[15] !== t4) {
    t6 = t4 === undefined ? [] : t4;
    $[15] = t4;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const buttons = t6;
  const testId = t5 === undefined ? "image-with-cta-section" : t5;
  let t7;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      defaultBaseDelay: 0.04
    };
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  useRevealAnim(t7);
  const isFull = layout === "full";
  let t8;
  if ($[18] !== isFull || $[19] !== titleClassName) {
    t8 = cn("text-sub-h2 font-noto-bold where-span:text-inline-wrap text-center", {
      "text-sub-h1 relative text-shadow-black": isFull
    }, titleClassName);
    $[18] = isFull;
    $[19] = titleClassName;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const t9 = !isFull;
  let t10;
  if ($[21] !== isFull || $[22] !== logoClassName || $[23] !== t9) {
    t10 = cn({
      "max-w-31": isFull,
      "max-w-54": t9
    }, logoClassName);
    $[21] = isFull;
    $[22] = logoClassName;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== buttons || $[26] !== layout || $[27] !== logo || $[28] !== t10 || $[29] !== t8 || $[30] !== theme || $[31] !== title || $[32] !== tracking) {
    t11 = <ContentBlock title={title} logo={logo} buttons={buttons} theme={theme} tracking={tracking} titleClassName={t8} logoClassName={t10} layout={layout} />;
    $[25] = buttons;
    $[26] = layout;
    $[27] = logo;
    $[28] = t10;
    $[29] = t8;
    $[30] = theme;
    $[31] = title;
    $[32] = tracking;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  const content = t11;
  const t12 = variant === "gray";
  const t13 = variant === "dark";
  const t14 = variant === "red";
  let t15;
  if ($[34] !== className || $[35] !== t12 || $[36] !== t13 || $[37] !== t14) {
    t15 = cn(className, {
      [styles.bgGradientGray]: t12,
      [styles.bgGradientBlack]: t13,
      [styles.bgGradientRed]: t14
    });
    $[34] = className;
    $[35] = t12;
    $[36] = t13;
    $[37] = t14;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== testId) {
    t16 = createDataAttributes({
      test: testId
    });
    $[39] = testId;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = createDataAttributes({
      test: "container"
    });
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== content || $[43] !== image || $[44] !== imageDesktop || $[45] !== isFull) {
    t18 = <Container className="grid h-full min-h-75 grid-cols-12 gap-x-6" {...t17}>{isFull ? <div className="relative z-10 col-span-12 flex min-h-75 flex-col items-center justify-center gap-y-6">{!!(image || imageDesktop) && <Image imageClassName="opacity-30" rootMargin="20% 0px 0px 0px" src={image?.src ?? imageDesktop?.src ?? ""} alt="Background" width={600} height={400} layout="fill" sources={[{
          srcset: imageDesktop?.src ?? image?.src ?? "",
          media: {
            minWidth: 1024
          },
          options: {
            width: 1024
          }
        }, ...generateSources("tablet", {
          mobileSrc: image?.src ?? ""
        }), ...generateSources("mobile", {
          mobileSrc: image?.src ?? ""
        })]} />}{content}</div> : <>{!!image && <div className="relative col-span-6 hidden lg:block" data-revealanim={true}><Image src={image.src} alt={image.alt || ""} width={image.width} height={image.height} layout="fill" sizes="(min-width: 1024px) 576px, 100vw" /></div>}<div className={cn("col-span-12 flex items-center justify-center", {
          "lg:col-span-5 lg:col-start-7 xl:col-span-4": !isFull
        })}>{content}</div></>}</Container>;
    $[42] = content;
    $[43] = image;
    $[44] = imageDesktop;
    $[45] = isFull;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== props || $[48] !== t15 || $[49] !== t16 || $[50] !== t18) {
    t19 = <Section size="none" className={t15} {...props} data-revealanim-group={true} {...t16}>{t18}</Section>;
    $[47] = props;
    $[48] = t15;
    $[49] = t16;
    $[50] = t18;
    $[51] = t19;
  } else {
    t19 = $[51];
  }
  return t19;
};